import { apiRoutes } from 'config/apiRoutes'
import { RentalRes } from 'features/rentals/types/rentals.types'
import { useQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'
import { useParams } from 'libs/router'
import { useContext } from 'react'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'

export const useFetchRental = () => {
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()
	const { auth } = useContext(AuthContext)

	const {
		data: rental,
		isFetching: loadingRental,
		isSuccess: isRentalSuccess
	} = useQuery<RentalRes>({
		queryKey: queryKeys.rentals.detail(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.rental(params.id as string)),
		enabled: !!auth.accessToken
	})

	return {
		rental,
		loadingRental,
		isRentalSuccess
	}
}
